export const AUDIT_ACTION_TYPES = [
  'Create',
  'Update',
  'Delete',
  'View',
  'Certify',
  'Regenerate',
  'Export',
  'Login',
];

export const filterAuditEvents = (events, filters = {}) => {
  let list = [...(events || [])];

  if (filters.query) {
    const needle = filters.query.toLowerCase();
    list = list.filter((e) =>
      [e.action_type, e.actor_name, e.resource, e.details, e.tenant_name]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(needle))
    );
  }
  if (filters.action_type && filters.action_type !== 'all') {
    list = list.filter((e) => e.action_type === filters.action_type);
  }
  if (filters.actor) {
    const needle = filters.actor.toLowerCase();
    list = list.filter((e) => (e.actor_name || '').toLowerCase().includes(needle));
  }
  if (filters.date_from) {
    const from = new Date(filters.date_from).getTime();
    list = list.filter((e) => new Date(e.created_at).getTime() >= from);
  }
  if (filters.date_to) {
    const to = new Date(filters.date_to).getTime() + 86400000;
    list = list.filter((e) => new Date(e.created_at).getTime() < to);
  }

  return list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
};

export const exportAuditLogCsv = (events, filename = 'audit-log.csv') => {
  const headers = ['Timestamp', 'Action', 'Actor', 'Resource', 'Details', 'Tenant'];
  const rows = (events || []).map((e) => [
    e.created_at,
    e.action_type,
    e.actor_name,
    e.resource,
    e.details,
    e.tenant_name || '',
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell || '').replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
